// extracted by mini-css-extract-plugin
module.exports = {"Input":"_8mc87r"};